import { TABLE_ORDER_PARAM, TABLE_SORT_PARAM } from '../DataTable.constants'
import type { ColumnDef, TableSort } from '../DataTable.types'
import { getColumnSortKey } from './getColumnSortKey'

export function readTableSortFromParams<T>(
  params: URLSearchParams,
  columns: readonly ColumnDef<T>[],
  defaultSortHeader?: string
): TableSort {
  const requestedKey = params.get(TABLE_SORT_PARAM)
  const direction = params.get(TABLE_ORDER_PARAM) === 'desc' ? 'desc' : 'asc'
  const defaultIndex = Math.max(
    0,
    columns.findIndex((column) => column.header === defaultSortHeader)
  )
  if (requestedKey === null) {
    return { columnIndex: defaultIndex, direction }
  }
  const matchedIndex = columns.findIndex(
    (column) => getColumnSortKey(column.header) === requestedKey
  )
  if (matchedIndex === -1) {
    return { columnIndex: defaultIndex, direction: 'asc' }
  }
  return { columnIndex: matchedIndex, direction }
}
